const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class VideoGallery extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    document.addEventListener('click', this.handleTrigger)

    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(this.els.close.element, 'click', this.handleClose)
  }

  handleClose () {
    this.close()
    document.body.classList.remove('util-SiteOverflowed')
  }

  handleTrigger (event) {
    if (!event.target.closest(this.externalEls?.trigger?.selector)) return

    const counter = parseInt(
      event.target.closest(this.externalEls?.trigger?.selector).dataset
        .videoIndex,
      10,
    )

    this.showModal()
    document.body.classList.add('util-SiteOverflowed')

    if (this.carousel) {
      this.carousel.update()

      this.carousel.moveToIdx(counter, false, { duration: 0 })
    }
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('video-gallery')) {
  customElements.define('video-gallery', VideoGallery, { extends: 'dialog' })
}
